import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { ConfigurationService } from "src/services/configuration.service";
import { ConfigurationInfo } from "../models/configuration-info";



@Injectable({
  providedIn: 'root'
})
export class ConfigurationResolver implements Resolve<any> {
  constructor(private configurationService: ConfigurationService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    // console.log("resolver")
    this.configurationService.getFranchiseAndCouponFlags().subscribe(res => {
        if(res && res.data){
          // console.log(res)
          const info = new ConfigurationInfo(res.data)
          // console.log(info)
          this.configurationService.setFlagsInLocalStorage(info.franchiseEnable,info.distributorEnable ,info.couponEnable, info.client, info.thirdPartyEnabled, info.clientId, info.operatorId,info.isPlan)
        }
    },err => {
      // console.log(err)
      this.configurationService.setFlagsInLocalStorage(false, false, false, '', false, '', '','')
    });
    return of(true);
  }
}



